<template>
  <div class="partner-page">
    <header>
      <div class="normal-header-block">
        <div class="container">
          <div class="slogan-container">
            <h1>和鲸获得了<br/>行业顶尖客户的认可</h1>
          </div>
        </div>
      </div>
    </header>
    <section>
      <div class="bg-block bg-partner">
        <div class="partner-container container">
          <div class="partner-content">
            <div class="partner-flex-wrapper">
              <div class="partner-col">
                <div class="partner-card" v-for="(item, index) in leftData" :key="index">
                  <div class="partner-logo">
                    <img :src="`https://cdn.kesci.com/client/logo/v2/${item.logo}.png`">
                  </div>
                  <div class="partner-detail">
                    <h3>{{item.name}}</h3>
                    <p>{{item.intro}}</p>
                    <a @click="$router.push({name: 'case', params: {id: item.logo}})">查看详情 ></a>
                  </div>
                </div>
              </div>
              <div class="partner-col">
                <div class="partner-card" v-for="(item, index) in midData" :key="index">
                  <div class="partner-logo">
                    <img :src="`https://cdn.kesci.com/client/logo/v2/${item.logo}.png`">
                  </div>
                  <div class="partner-detail">
                    <h3>{{item.name}}</h3>
                    <p>{{item.intro}}</p>
                    <a @click="$router.push({name: 'case', params: {id: item.logo}})">查看详情 ></a>
                  </div>
                </div>
              </div>
              <div class="partner-col">
                <div class="partner-card" v-for="(item, index) in rightData" :key="index">
                  <div class="partner-logo">
                    <img :src="`https://cdn.kesci.com/client/logo/v2/${item.logo}.png`">
                  </div>
                  <div class="partner-detail">
                    <h3>{{item.name}}</h3>
                    <p>{{item.intro}}</p>
                    <a @click="$router.push({name: 'case', params: {id: item.logo}})">查看详情 ></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import partners from '../data/partners.json';
export default {
  created() {
    this.partners = partners;
  },
  data() {
    return {
      partners: []
    };
  },
  computed: {
    leftData() {
      return this.partners.slice(0, 7);
    },
    midData() {
      return this.partners.slice(7, 14);
    },
    rightData() {
      return this.partners.slice(14, 20);
    }
  }
};
</script>
<style lang="scss">
.partner-page {
  .normal-header-block {
    background-image: url("../assets/banners/partner.jpg");
  }
  .partner-flex-wrapper {
    display: flex;
    justify-content: space-between;
  }
  .partner-col {
    width: 33%;
    padding: 0px 12px;
  }
  .partner-card {
    margin-bottom: 24px;
    overflow: hidden;
    max-height: 140px;
    transition: max-height .3s ease-in-out;
    &:hover {
      max-height: 300px;
      .partner-detail {
        opacity: 1;
      }
      .partner-logo {
        opacity: 0;
      }
    }
  }
  .partner-logo {
    opacity: 1;
    display: flex;
    height: 140px;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    transition: opacity .3s ease-in-out;
    img {
      height: 56px;
      width: auto;
    }
  }
  .partner-detail {
    opacity: 0;
    position: relative;
    height: 300px;
    top: -140px;
    // opacity: 0;
    background-color: #092846;
    background-image: url('../assets/bg-user-card.png');
    background-size: cover;
    padding: 24px 36px;
    transition: opacity .3s ease-in-out;
    h3 {
      color: #fff;
    }
    p {
      color: #fff;
    }
    a {
      cursor: pointer;
      position: absolute;
      bottom: 24px;
      font-size: 12px;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partner.vue